function isNumeric(value: string) {
  // isFinite(value) coerced the string; Number() does the same coercion
  // explicitly now that the parameter is typed.
  return !isNaN(parseFloat(value)) && isFinite(Number(value));
}
export const cleanNumber = (str: string): string | number => {
  if (!str) {
    return 0;
  }
  if (isNumeric(str)) {
    return str;
  }
  const cleanedString = str.replace(/[\s,]+/g, '');
  // Convert to a number
  const number = parseInt(cleanedString, 10);
  return number;
};
